// extracted by mini-css-extract-plugin
export default {"container":"ArtistHelpPage_container__+uQze","sections":"ArtistHelpPage_sections__XFaQY","section":"ArtistHelpPage_section__Uxev-","sectionRoot":"ArtistHelpPage_sectionRoot__VUJKI"};